import type { SortDropdownOption } from '@/shared/ui/SortDropdown'

import type { SortOption } from '../domain/sortJourneys'

export const JOURNEY_SORT_OPTIONS: (SortDropdownOption & { value: SortOption })[] = [
  { value: 'recent', label: 'Mais recentes' },
  { value: 'mostCompleted', label: 'Mais concluídas' },
  { value: 'leastProgress', label: 'Menor progresso' },
  { value: 'mostProgress', label: 'Maior progresso' },
  { value: 'az', label: 'A-Z' },
  { value: 'za', label: 'Z-A' }
]
